<template>
  <div style="width: 100%; height: 100%;pointer-events:all">
    <iframe
      style="width: 100%; height: 100%"
      src="http://app2.ainongye.cn/zt/api/bigdata/changfeng/berry/?hide=1"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'QualityIndex',
  mounted() {
    console.log('【↑↑↑】', this.$options.name)
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  },
}
</script>



// WEBPACK FOOTER //
// src/components/quality/Index.vue